import { useState, useLayoutEffect, ReactElement } from "react";
import { Router, RouterProps } from "react-router";
import { createBrowserHistory } from "history";

export const history = createBrowserHistory();

export const HistoryRouter = ({
  basename,
  children,
  ...rest
}: RouterProps): ReactElement => {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(setState), []);

  return (
    <Router
      {...rest}
      basename={basename}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    >
      {children}
    </Router>
  );
};

export default HistoryRouter;
